import { render, staticRenderFns } from "./DocumentListRequirementSection.vue?vue&type=template&id=4ffda11d&scoped=true&"
import script from "./DocumentListRequirementSection.vue?vue&type=script&lang=js&"
export * from "./DocumentListRequirementSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListRequirementSection.vue?vue&type=style&index=0&id=4ffda11d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffda11d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VProgressLinear,VRow,VSimpleTable})
